// src/components/atomic-crm/activities/index.ts
import { ActivityList } from "./ActivityList";
import { TaskCreate } from "../tasks/TaskCreate";



export default {
  list: ActivityList,
  create: TaskCreate,
};
